import DirectionServicesView from '@/components/DirectionServicesView';

export default function ServicesPage(props) {
  return <DirectionServicesView {...props} isServicesIndex />;
}
